// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:48.833Z
// Property: Creekwood Apartments (ID: 6767906449165599)
// Collections: 34 amenities, 11 floorplans (live), 53 photos, 70 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165599",
  "property_external_id": "eb2mr4n",
  "property_zillow_url": "https://www.zillow.com/homedetails/8418-S-77th-East-Ave-Tulsa-OK-74133/2063681234_zpid/",
  "property_apartments_url": "https://www.apartments.com/creekwood-apartments-tulsa-ok/eb2mr4n/",
  "property_google_business_url": "https://www.google.com/maps/place/Creekwood+Apartments/data=!4m2!3m1!1s0x0:0x3b1183d6517d31d4?sa=X&ved=2ahUKEwiq68OL97ySAxVLhIkEHVXUCPAQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "creekwood-apartments",
  "property_name": "Creekwood Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/creekwood/",
  "property_domain": null,
  "property_address": "8418 S. 77th E. Ave.",
  "property_full_address": "8418 S. 77th E. Ave., Tulsa, OK, 74133",
  "property_address_1": "8418 S. 77th E. Ave.",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0407",
  "property_address_longitude": "-95.8873",
  "property_email": "creekwood@caseusa.com",
  "property_phone": "(539) 212-4189",
  "property_call_tracking_phone": "844-531-0241",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Nestled in the heart of Tulsa, Creekwood Apartments offers a vibrant lifestyle with thoughtfully designed one and two-bedroom floor plans. Enjoy resort-style amenities like a sparkling pool, fitness center, and inviting clubhouse. Elevate your living experience—schedule a tour and uncover your perfect sanctuary in our welcoming community today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Creekwood Apartments, where modern living meets unparalleled comfort in the heart of Tulsa, Oklahoma. Offering a diverse selection of spacious floor plans, including one and two-bedroom options, our community is designed to meet all your lifestyle needs. Step inside and experience a range of contemporary features, from high-speed internet access and air conditioning to walk-in closets and fully equipped kitchens with dishwashers and microwaves.\n\nAt Creekwood, amenities are abundant. Dive into relaxation at our sparkling pool or stay fit in our state-of-the-art fitness center. Families will appreciate our playground and picnic areas, while sports enthusiasts can enjoy basketball and tennis courts. Our clubhouse, business center, and on-site maintenance ensure that you have everything you need at your fingertips.\n\nOur pet-friendly community is designed with your convenience in mind, featuring furnished units, public transportation access, and ample parking space. Whether you want to unwind by the fire in your cozy apartment or soak up the sun on the sundeck, Creekwood Apartments provides a perfect sanctuary for those seeking both tranquility and engagement.\n\nExperience the ideal blend of community and comfort at Creekwood Apartments. Don’t miss out on this opportunity! Find your new home today by browsing our availability or scheduling a tour to visit our vibrant community. Your dream lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019fb44b-4f80-7574-82a0-ddad5c975fb0.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings and surrounding grounds, including parking lots and trees.",
    "public_id": "019fb44b-4f80-7574-82a0-ddad5c975fb0",
    "storage_key": "property/6767906449165599/019fb44b-4f80-7574-82a0-ddad5c975fb0.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "651",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.85253456221197",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets are subject to management approval. Maximum of two pets per unit. Breed restrictions apply.",
  "property_pet_policy_description": "Pets are subject to management approval. Maximum of two pets per unit. One-time non‑refundable fee: $500 per pet. Monthly pet rent: $30 per pet. No weight limit specified; breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://creekwoodapartmentstulsa.securecafe.com/onlineleasing/creekwood-apartments-0/floorplans.aspx",
  "property_resident_portal_url": "https://creekwoodapartmentstulsa.securecafe.com/residentservices/creekwood-apartments-0/userlogin.aspx",
  "property_apply_now_url": "https://creekwoodapartmentstulsa.securecafe.com/onlineleasing/creekwood-apartments-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-a7ec-763d-8c44-281e4ad06ca9.webp",
  "property_primary_logo_media": {
    "alt_text": "Creekwood Apartment Homes logo",
    "public_id": "019cfb3d-a7ec-763d-8c44-281e4ad06ca9",
    "storage_key": "property/6767906449165599/019cfb3d-a7ec-763d-8c44-281e4ad06ca9.webp",
    "width": 440,
    "height": 133
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-af76-77e9-a53d-845c88dcc05c.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3e-af76-77e9-a53d-845c88dcc05c",
    "storage_key": "property/6767906449165599/019cfb3e-af76-77e9-a53d-845c88dcc05c.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3f-0042-7449-aeec-49c7a95a37e6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Creekwood Apartment Homes logo",
    "public_id": "019cfb3f-0042-7449-aeec-49c7a95a37e6",
    "storage_key": "property/6767906449165599/019cfb3f-0042-7449-aeec-49c7a95a37e6.webp",
    "width": 440,
    "height": 133
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3f-144a-710a-be68-09d50d3bf608.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Creekwood Apartment Homes logo",
    "public_id": "019cfb3f-144a-710a-be68-09d50d3bf608",
    "storage_key": "property/6767906449165599/019cfb3f-144a-710a-be68-09d50d3bf608.webp",
    "width": 440,
    "height": 133
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#5c7375",
  "property_secondary_color": "#a6a8ab",
  "property_font_color": null,
  "property_color_4": "#b8b1a8",
  "property_color_3": "#3d3d3f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "600 - 800",
  "property_sqft_min": "600",
  "property_sqft_max": "800",
  "property_price_range": "904 - 994",
  "property_price_min": "904",
  "property_price_max": "994",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/CreekwoodTulsa/photos/d41d8cd9/1511737350955155/",
  "property_instagram_url": "https://www.instagram.com/creekwood_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJp84lS-WNtocR1DF9UdaDETs",
  "property_youtube_url": "https://www.youtube.com/watch?v=c9TnptABa-M",
  "property_yelp_url": "https://www.yelp.com/biz/creekwood-apartments-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@creekwoodaptstulsa",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Creekwood Apartments",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to Creekwood Apartments in Tulsa, OK—where modern living meets comfort and convenience. Choose from spacious one- and two-bedroom layouts, complete with luxurious amenities like a sparkling pool, fitness center, and welcoming clubhouse. Embrace a lifestyle that balances relaxation and recreation, all just moments from your doorstep.",
  "property_home_floorplans_blurb": "Welcome to Creekwood Apartments in Tulsa, OK, where your dream home awaits! With thoughtfully designed one and two-bedroom floor plans, we offer the ideal blend of comfort and style. Browse our available apartments today to find a space that truly reflects your lifestyle and aspirations.",
  "property_home_gallery_blurb": "Welcome to Creekwood Apartments in Tulsa, OK, where comfort meets convenience! Choose from stylish one and two-bedroom floor plans, complete with modern amenities like a refreshing pool, a state-of-the-art fitness center, and inviting courtyards. Picture yourself enjoying life’s little luxuries, from sun-soaked patios to cozy fireplaces.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Tulsa, Creekwood Apartments offers seamless living with a variety of thoughtfully designed one and two-bedroom floor plans. Immerse yourself in the vibrant neighborhood as you uncover local favorites and essential hotspots. Your ideal lifestyle awaits—uncover the charm surrounding your new home today!",
  "property_home_reviews_blurb": "Embrace the charm of Creekwood Apartments, where residents rave, “We just love it!” Nestled in a vibrant Tulsa neighborhood, our community boasts friendly staff, spacious townhomes, and luxurious amenities like a 24-hour gym and pools. Experience affordable living without compromise—your perfect home awaits! See what our residents have to say!",
  "property_neighborhood_blurb": "Welcome to Creekwood Apartments in Tulsa, OK, where comfort meets convenience. Nestled near top educational institutions like Oral Roberts University and Union High School Freshman Academy, our community offers spacious one- and two-bedroom floor plans. See what’s around us and uncover the vibrant local attractions just beyond your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Creekwood Apartments in Tulsa, enjoy a vibrant lifestyle with top-notch amenities like a refreshing pool, fitness center, and spacious clubhouse. Our thoughtfully designed one and two-bedroom apartments boast modern comforts, from cozy fireplaces to convenient Wi-Fi. Join us and embrace a community tailored for relaxation and connectivity!",
  "property_applynow_blurb": "Welcome to Creekwood Apartments in Tulsa, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans featuring modern amenities like a pool, fitness center, and cozy fireplaces. Enjoy outdoor living with a picnic area and basketball courts. Your perfect home awaits—lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Creekwood Apartments in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans offer an inviting sanctuary tailored to your lifestyle. Whether you're seeking cozy comfort or spacious living, we have the perfect fit for you. Have questions? Contact our leasing team today to learn more!",
  "property_faqs_blurb": "At Creekwood Apartments in Tulsa, Oklahoma, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Our FAQs page is your go-to source for information about our vibrant community and amenities. Find the answers you seek and elevate your living experience today!",
  "property_floorplans_blurb": "At Creekwood Apartments in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Each layout offers ample space, modern finishes, and a welcoming ambiance. Browse our available apartment homes today to find the perfect floor plan that fits your needs and style!",
  "property_gallery_blurb": "At Creekwood Apartments in Tulsa, Oklahoma, every corner invites comfort and convenience. Imagine unwinding by the pool, enjoying a barbecue in the picnic area, or hosting friends in your stylish sunroom. With a variety of floor plans and a wealth of amenities, picture yourself living the lifestyle you deserve!",
  "property_interactivemap_blurb": "At Creekwood Apartments in Tulsa, you'll find a vibrant blend of comfort and convenience. Choose from spacious one- or two-bedroom floor plans, complete with premium amenities like a refreshing pool, cutting-edge fitness center, and inviting clubhouse. Our interactive community map makes finding your perfect home effortless!",
  "property_pets_blurb": "Nestled in the heart of Tulsa, Creekwood Apartments offers a vibrant living experience with scenic views and modern amenities. With management-approved pets allowed, you can enjoy your home with your furry companions—subject to breed restrictions. Elevate your lifestyle today in our inviting community, where comfort meets convenience.",
  "property_referafriend_blurb": "At Creekwood Apartments in Tulsa, Oklahoma, our charming one and two-bedroom floor plans are designed for comfort and style. Share the joy of great living with your friends—refer a friend today and help them find their new home in our vibrant community. Great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Creekwood Apartments, where comfort meets convenience in beautiful Tulsa, Oklahoma. Choose from our stylish one and two-bedroom floor plans tailored to your lifestyle. Log in to the resident portal for easy rent payments, maintenance requests, and more—making apartment living effortless and enjoyable!",
  "property_reviews_blurb": "At Creekwood Apartments in Tulsa, our residents rave about their experiences! With friendly staff and well-maintained living spaces, one resident shared, “We just love it!” From family-friendly townhouses to a 24-hour gym and gorgeous pools, hear what makes our community truly special! ",
  "property_created_at": "1753982382354",
  "property_scheduletour_blurb": "Experience the charm of Creekwood Apartments in Tulsa, Oklahoma, where your dream one or two-bedroom home awaits. Spacious layouts and modern amenities create an inviting atmosphere. Intrigued? Hear firsthand what our residents love about living here—schedule a tour today and envision your future at Creekwood!",
  "property_thankyou_blurb": "Thank you for reaching out to Creekwood Apartments in Tulsa, Oklahoma! With thoughtfully designed one and two-bedroom floor plans, we offer the perfect space to call home. Our team looks forward to connecting with you soon to answer your questions and help you find your ideal apartment.",
  "property_virtualtours_blurb": "Experience the charm of Creekwood Apartments in Tulsa, Oklahoma, where spacious one- and two-bedroom floor plans offer the perfect balance of comfort and style. Ready to envision your new home? Immerse yourself in our virtual tour and see how Creekwood can elevate your lifestyle today!",
  "property_copyright": "2025 All Rights Reserved. Creekwood Apartments",
  "property_seo_title_home": "Creekwood Apartments | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Experience the best of Tulsa at Creekwood Apartments, where comfort meets style. Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Creekwood Apartments in Tulsa! Choose from stylish one and two-bedroom floor plans designed for comfort and convenience. Browse now!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Creekwood Apartments in Tulsa, OK, with top-notch amenities like a pool, fitness center, and spacious floor plans. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Capture your dream lifestyle at Creekwood Apartments in Tulsa! With stunning amenities, spacious floor plans, and a vibrant community, visualize your perfect home today.",
  "property_seo_title_virtualtours": "Virtual Tours | Creekwood Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Creekwood Apartments in Tulsa! Take a virtual tour of our spacious one and two-bedroom floor plans and imagine your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Creekwood Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect haven at Creekwood Apartments in Tulsa! Use our interactive map to discover unique layouts, amenities, and pricing for your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover Tulsa's hidden gems at Creekwood Apartments. Dive into local favorites and explore the vibrant neighborhood around our one and two-bedroom homes!",
  "property_seo_title_contact": "Contact Us | Creekwood Apartments",
  "property_seo_description_contact": "Reach out to Creekwood Apartments in Tulsa! From cozy one-bedroom to spacious two-bedroom floor plans, we’re here to help you find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Creekwood Apartments in Tulsa, OK. From floor plans to amenities, explore all you need to know for your ideal living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Experience life at Creekwood Apartments in Tulsa, where comfort meets community. Check out our residents' reviews and see why you'll love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "\"Experience the charm of Creekwood Apartments in Tulsa! Choose from spacious one and two-bedroom homes with top-notch amenities. Lease online today!\"",
  "property_seo_title_residentaccess": "Resident Access | Creekwood Apartments",
  "property_seo_description_residentaccess": "Log in to Creekwood Apartments' resident portal for seamless rent payments, maintenance requests, and community updates. Your convenience awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Creekwood Apartments",
  "property_seo_description_referafriend": "Help your friends find their perfect home at Creekwood Apartments in Tulsa! Refer a friend today and enjoy the benefits of living in a vibrant community together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Creekwood Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Creekwood Apartments in Tulsa! Tour our vibrant community today and find your perfect home amidst serene surroundings and modern comforts.",
  "property_seo_title_privacy": "Privacy Policy | Creekwood Apartments",
  "property_seo_description_privacy": "At Creekwood Apartments in Tulsa, your privacy matters! Read our policy to learn how we protect your personal information while you enjoy serene living.",
  "property_seo_title_accessibility": "Website Accessibility | Creekwood Apartments",
  "property_seo_description_accessibility": "Embrace a welcoming community at Creekwood Apartments in Tulsa, where accessibility meets comfort. Join us in fostering digital inclusion for all residents.",
  "property_seo_title_sitemap": "Sitemap | Creekwood Apartments",
  "property_seo_description_sitemap": "Find your perfect home at Creekwood Apartments in Tulsa, Oklahoma. Check out our sitemap for easy navigation and discover all we offer today!",
  "property_seo_title_thankyou": "Thank You | Creekwood Apartments",
  "property_seo_description_thankyou": "Thanks for reaching out to Creekwood Apartments in Tulsa! Our team will be in touch soon to help you find your perfect new home amidst nature's beauty.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865139128",
  "amenities": [
    {
      "id": "ec_7834872c33aa29c1846c56b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396498",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22ca5ab28dadecfc5ba4a91f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396502",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_612f9d374beca4b8a6cff99b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396504",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2be02f85140aea322aa21d1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396505",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bab347f990bc41c80cc4e457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396506",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_621ae80f8c6bc9c1f394f590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396507",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7229ca17677ce93e5972d81f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396508",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d5406d75167ab7b7c541e0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396510",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72c1b6bb879ce630bad32f4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396512",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69cee3040020f1b0ab2b2f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396513",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46e68335f2da611d921dcf89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396514",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a601e926b8f5bbd4c5f91a6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396515",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee1ed8ce3c9863e3a3f484fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "128042528",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_914fa113c4061df60da4451c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396516",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_789e921f127ab355e788cb83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396517",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_797135b17b221d3595685366",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127396518",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee5bb91f03cec5bf20132fab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "128017280",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8da90820f111fe5dfdc4176",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397982",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37eb17748a6073528b7e2660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397983",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c6697ded2b396ddcfe2a64a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397984",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b5ad3fe8aae78833b7661b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397985",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3793ec31a3a4235da4e6501d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397986",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44a80e368ec30cab7d7195b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397987",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0bb68d24ce51f4d5a0f894c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397988",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a28cc969c6dfc5d8ffc468cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397989",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_044f7d52ed8fd9edff99d126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397990",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b51fb0227c2c72b3431ce44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397991",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_930d06d637f7aeada31c1a0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397992",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e869d58f49e5aba0ce3b5c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397993",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_330e53606fda871a515c84d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397994",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ee3879f3016004ee0be434e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397995",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1901707eece99ece99af0ea0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397996",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9432f0571ef7fc3d26fe214b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397997",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fc53c05a5b03e637c8e1ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "yardi",
      "external_id": "127397998",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bc91c0bd-712d-4487-8c81-97ebae0d0336",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1949-7090-7478-a56c-0483f3d6a284.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, windows, balconies, stairs, and grassy landscaping under a blue sky.",
        "public_id": "019f1949-7090-7478-a56c-0483f3d6a284",
        "storage_key": "property/6767906449165599/019f1949-7090-7478-a56c-0483f3d6a284.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Explore the inviting exterior of our community, showcasing classic brick and siding architecture, multiple apartment units, and well-maintained green spaces. A perfect place to call home.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, windows, balconies, stairs, and grassy landscaping under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50dcff3f-c496-4287-b334-60b79df17497",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1949-6ca8-71a4-8bf4-4a5b70c127e1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, green lawn, trees, and covered parking on a sunny day.",
        "public_id": "019f1949-6ca8-71a4-8bf4-4a5b70c127e1",
        "storage_key": "property/6767906449165599/019f1949-6ca8-71a4-8bf4-4a5b70c127e1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience comfortable living at our apartment community. Enjoy the well-maintained grounds, attractive building exteriors with brick accents, and convenient covered parking.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, green lawn, trees, and covered parking on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c54402f3-a65a-4bea-964f-b741b3195ee1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1949-c238-7459-a83d-65fcf0706131.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with grass and walkways.",
        "public_id": "019f1949-c238-7459-a83d-65fcf0706131",
        "storage_key": "property/6767906449165599/019f1949-c238-7459-a83d-65fcf0706131.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the community's architecture and grounds. Includes a disabled parking sign.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with grass and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9fcdfe4-5fd3-4d0a-9f9e-cc3288ad3ae5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1949-b187-71cb-935d-7a2d1b682ac2.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with manicured lawns and trees.",
        "public_id": "019f1949-b187-71cb-935d-7a2d1b682ac2",
        "storage_key": "property/6767906449165599/019f1949-b187-71cb-935d-7a2d1b682ac2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Well-maintained apartment buildings with lush green lawns and mature trees, offering a serene community atmosphere.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e40c773f-87c0-4faf-bf5e-41c2fa7d2095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1949-8303-753d-829d-37b954f2053d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a picnic table and grill in the foreground on a sunny day.",
        "public_id": "019f1949-8303-753d-829d-37b954f2053d",
        "storage_key": "property/6767906449165599/019f1949-8303-753d-829d-37b954f2053d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community picnic area, perfect for a relaxing afternoon or a barbecue with friends and family.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a picnic table and grill in the foreground on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4e79dd6-28a8-4410-8e6e-7aae0ee81f5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-fb7b-771b-b7be-5f7f4d957156.webp",
      "image_media": {
        "alt_text": "Grassy pet park with agility equipment including a red tunnel and jumps, a red bench, and a pet waste station.",
        "public_id": "019f1948-fb7b-771b-b7be-5f7f4d957156",
        "storage_key": "property/6767906449165599/019f1948-fb7b-771b-b7be-5f7f4d957156.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our spacious on-site pet park is perfect for your furry friends to run, play, and socialize. Featuring fun agility equipment and plenty of green space for endless enjoyment, it's a true pet paradise.",
      "link": "",
      "alt_text": "Grassy pet park with agility equipment including a red tunnel and jumps, a red bench, and a pet waste station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f59fcc2d-0ea6-4d70-979f-02b9de5daa99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-f30e-728d-afda-a6e09b58f651.webp",
      "image_media": {
        "alt_text": "A fenced community dog park with green grass, dog agility equipment, and surrounding trees under a blue sky.",
        "public_id": "019f1948-f30e-728d-afda-a6e09b58f651",
        "storage_key": "property/6767906449165599/019f1948-f30e-728d-afda-a6e09b58f651.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our pet-friendly community offers a fantastic fenced dog park, providing a safe and engaging space for your canine companions to play and socialize outdoors.",
      "link": "",
      "alt_text": "A fenced community dog park with green grass, dog agility equipment, and surrounding trees under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d24fa417-ed6f-4944-967a-c92438d03210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-cb52-72c6-a70d-051261f9f776.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with dark gray surface, white lines, and a hoop. Apartment buildings and parked cars are visible behind the fence.",
        "public_id": "019f1948-cb52-72c6-a70d-051261f9f776",
        "storage_key": "property/6767906449165599/019f1948-cb52-72c6-a70d-051261f9f776.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Shoot some hoops or play a pick-up game on our community's outdoor basketball court, a fun and active amenity for residents of all ages. It's the perfect spot to enjoy the outdoors and stay active.",
      "link": "",
      "alt_text": "Outdoor basketball court with dark gray surface, white lines, and a hoop. Apartment buildings and parked cars are visible behind the fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c45e696-a082-4359-8914-3f36a9af7672",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-d2b3-743f-8842-100ddc733228.webp",
      "image_media": {
        "alt_text": "Outdoor community basketball court with two hoops, chain-link fence, and lush green trees in the background.",
        "public_id": "019f1948-d2b3-743f-8842-100ddc733228",
        "storage_key": "property/6767906449165599/019f1948-d2b3-743f-8842-100ddc733228.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a friendly game on our community's outdoor basketball court, complete with two hoops and surrounded by mature landscaping for a refreshing outdoor experience. Perfect for active residents.",
      "link": "",
      "alt_text": "Outdoor community basketball court with two hoops, chain-link fence, and lush green trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5dd2c90d-5241-45ea-b116-bef542cdb5e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-9054-736b-9ab0-0f1093e0143c.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with light gray siding, brick chimney, landscaped grounds, and a covered carport.",
        "public_id": "019f1948-9054-736b-9ab0-0f1093e0143c",
        "storage_key": "property/6767906449165599/019f1948-9054-736b-9ab0-0f1093e0143c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover the inviting exterior of our community buildings, featuring stylish light gray siding, distinctive brick chimneys, well-maintained landscaping, and convenient covered carports. Enjoy the blend of comfort and curb appeal.",
      "link": "",
      "alt_text": "Exterior view of an apartment building with light gray siding, brick chimney, landscaped grounds, and a covered carport.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01676737-b342-4ae9-b19d-a51513ce1134",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-a76b-767d-a887-f1a4fddd0729.webp",
      "image_media": {
        "alt_text": "Children's playground with a wooden structure, yellow slide, and swings, surrounded by green grass and trees.",
        "public_id": "019f1948-a76b-767d-a887-f1a4fddd0729",
        "storage_key": "property/6767906449165599/019f1948-a76b-767d-a887-f1a4fddd0729.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our community playground offers a safe and fun outdoor space for residents of all ages. Enjoy the swings, slide, and play structure in a beautiful, shaded setting.",
      "link": "",
      "alt_text": "Children's playground with a wooden structure, yellow slide, and swings, surrounded by green grass and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c178bc44-3fe0-46f3-a32f-e279c9c994db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-fedc-776f-9d88-f38cf4d1c5ac.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with entrance stairs and surrounding greenery.",
        "public_id": "019f1948-fedc-776f-9d88-f38cf4d1c5ac",
        "storage_key": "property/6767906449165599/019f1948-fedc-776f-9d88-f38cf4d1c5ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building, showcasing its entrance, stairwell, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Apartment building exterior with entrance stairs and surrounding greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f551fe1-4448-4a25-9e1f-30c12b7bb646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-8366-72ae-afa6-8eb14cb96f54.webp",
      "image_media": {
        "alt_text": "Indoor fitness center with cardio machines, weight racks, and a view of the outdoor swimming pool.",
        "public_id": "019f1948-8366-72ae-afa6-8eb14cb96f54",
        "storage_key": "property/6767906449165599/019f1948-8366-72ae-afa6-8eb14cb96f54.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our spacious fitness center, featuring a wide range of cardio and strength training equipment. Enjoy bright interiors and a refreshing view of our sparkling pool.",
      "link": "",
      "alt_text": "Indoor fitness center with cardio machines, weight racks, and a view of the outdoor swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a5d2d27-f6d9-4f9a-92cd-2c0036e54e86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-ad4e-74c0-9c77-023c219a397b.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings in front of apartment buildings.",
        "public_id": "019f1948-ad4e-74c0-9c77-023c219a397b",
        "storage_key": "property/6767906449165599/019f1948-ad4e-74c0-9c77-023c219a397b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, complete with a slide and swings, perfect for residents of all ages.",
      "link": "",
      "alt_text": "Playground with slide and swings in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77847082-515d-4296-897c-f11bf1f85822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-82a6-707f-8c2c-0c76c79f8331.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a hot tub and lounge chairs under a bright blue sky.",
        "public_id": "019f1948-82a6-707f-8c2c-0c76c79f8331",
        "storage_key": "property/6767906449165599/019f1948-82a6-707f-8c2c-0c76c79f8331.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and refresh by our inviting community swimming pool and hot tub, surrounded by comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a hot tub and lounge chairs under a bright blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb4dbbfb-8bdd-4b88-8838-3429048b225f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-830e-7784-bdda-a8ae8e9d682e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, elliptical machines, and a fireplace.",
        "public_id": "019f1948-830e-7784-bdda-a8ae8e9d682e",
        "storage_key": "property/6767906449165599/019f1948-830e-7784-bdda-a8ae8e9d682e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and a cozy fireplace area.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, elliptical machines, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2f3a781-21be-4816-8025-b6e41ae00055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-82a7-701e-9275-4cddddfeff30.webp",
      "image_media": {
        "alt_text": "Blue swimming pool with lounge chairs and trees in the background.",
        "public_id": "019f1948-82a7-701e-9275-4cddddfeff30",
        "storage_key": "property/6767906449165599/019f1948-82a7-701e-9275-4cddddfeff30.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling blue swimming pool, complete with comfortable lounge chairs for sunbathing.",
      "link": "",
      "alt_text": "Blue swimming pool with lounge chairs and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89ca5b43-3bec-4216-a828-eac19c5753a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-80e9-77ee-ab00-bd962430391d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and surrounding apartment buildings.",
        "public_id": "019f1948-80e9-77ee-ab00-bd962430391d",
        "storage_key": "property/6767906449165599/019f1948-80e9-77ee-ab00-bd962430391d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or relax in the soothing hot tub. Lounge chairs and tables are available for your comfort and convenience.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e62d98f-5d1c-4776-b13a-9703a916fe94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-5903-76ec-b872-26a8aa75d6a9.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a queen-sized bed, decorative pillows, nightstand with lamp, armchair by a large window, and ceiling fan.",
        "public_id": "019f1947-5903-76ec-b872-26a8aa75d6a9",
        "storage_key": "property/6767906449165599/019f1947-5903-76ec-b872-26a8aa75d6a9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in your comfortable bedroom featuring a queen-sized bed, plush carpet, and ample natural light from the large window. Enjoy modern amenities like a ceiling fan and stylish decor in your new home.",
      "link": "",
      "alt_text": "Spacious bedroom with a queen-sized bed, decorative pillows, nightstand with lamp, armchair by a large window, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65a387bf-493f-4ce5-b9be-27afd83668ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-5d51-739f-a872-aeab028fe7e4.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and walk-in closet.",
        "public_id": "019f1947-5d51-739f-a872-aeab028fe7e4",
        "storage_key": "property/6767906449165599/019f1947-5d51-739f-a872-aeab028fe7e4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, ample storage with a dresser and walk-in closet, and a built-in vanity area.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44ab35e1-21b1-4a0b-9d5d-cefb696713b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-467a-763a-966d-4eb37cacef11.webp",
      "image_media": {
        "alt_text": "Bright kitchen with light wood cabinets, speckled countertops, white stove, black microwave, and white refrigerator.",
        "public_id": "019f1947-467a-763a-966d-4eb37cacef11",
        "storage_key": "property/6767906449165599/019f1947-467a-763a-966d-4eb37cacef11.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Our apartment kitchens feature warm wooden cabinetry, modern appliances including a stove, microwave, and refrigerator, and ample counter space for all your culinary needs. Enjoy stylish and functional living.",
      "link": "",
      "alt_text": "Bright kitchen with light wood cabinets, speckled countertops, white stove, black microwave, and white refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_589d5243-2ab1-45ff-9c4e-c8331b2ce2bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-6673-7158-830a-1b1537b81a53.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, and en-suite bathroom access.",
        "public_id": "019f1947-6673-7158-830a-1b1537b81a53",
        "storage_key": "property/6767906449165599/019f1947-6673-7158-830a-1b1537b81a53.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a plush queen-size bed, convenient bedside tables, and easy access to the en-suite bathroom.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, bedside tables, and en-suite bathroom access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0c869e0-e65c-4cd5-ae27-fbc85df428ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-2db2-72ca-9cf0-b0be491dd596.webp",
      "image_media": {
        "alt_text": "A kitchen with wooden cabinets, granite countertops, white appliances including a refrigerator, dishwasher, and oven.",
        "public_id": "019f1947-2db2-72ca-9cf0-b0be491dd596",
        "storage_key": "property/6767906449165599/019f1947-2db2-72ca-9cf0-b0be491dd596.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover a functional kitchen featuring warm wood cabinetry, granite-style countertops, and essential white appliances. An ideal space for preparing meals and daily living.",
      "link": "",
      "alt_text": "A kitchen with wooden cabinets, granite countertops, white appliances including a refrigerator, dishwasher, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_326bedc8-1df1-4071-b2d0-027bf9adb420",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-41a3-724e-9943-5555fb97fccb.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, double sink, white appliances, and a window with blinds.",
        "public_id": "019f1947-41a3-724e-9943-5555fb97fccb",
        "storage_key": "property/6767906449165599/019f1947-41a3-724e-9943-5555fb97fccb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, granite countertops, a double sink, and a full suite of white appliances, perfect for home-cooked meals.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, double sink, white appliances, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_661b85d7-654a-430d-b56f-c8c698fd16a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-10f3-70e9-887c-99b8867df364.webp",
      "image_media": {
        "alt_text": "Dining area with a table, chairs, and view into the kitchen.",
        "public_id": "019f1947-10f3-70e9-887c-99b8867df364",
        "storage_key": "property/6767906449165599/019f1947-10f3-70e9-887c-99b8867df364.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, featuring a table set for four and a view into the well-equipped kitchen.",
      "link": "",
      "alt_text": "Dining area with a table, chairs, and view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d08b7abc-e6ca-4352-a996-b28406bde0bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1946-d61a-747b-a630-eb0512feaf93.webp",
      "image_media": {
        "alt_text": "Cozy apartment living room with a lit fireplace, flat-screen TV, patterned armchair, coffee table, and a built-in bar area.",
        "public_id": "019f1946-d61a-747b-a630-eb0512feaf93",
        "storage_key": "property/6767906449165599/019f1946-d61a-747b-a630-eb0512feaf93.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this inviting apartment living room featuring a warm fireplace, entertainment center with a TV, and elegant decor. The space also includes a convenient built-in wet bar for entertaining guests.",
      "link": "",
      "alt_text": "Cozy apartment living room with a lit fireplace, flat-screen TV, patterned armchair, coffee table, and a built-in bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5156c8d6-7653-4d50-910f-6aae3758f191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-2bb9-7155-92bd-7ed12e77d3e8.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead cabinets and bi-fold doors.",
        "public_id": "019f1947-2bb9-7155-92bd-7ed12e77d3e8",
        "storage_key": "property/6767906449165599/019f1947-2bb9-7155-92bd-7ed12e77d3e8.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with ample storage space in the overhead cabinets. Perfect for keeping your clothes fresh and clean.",
      "link": "",
      "alt_text": "In-unit washer and dryer with overhead cabinets and bi-fold doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e54fd99-d458-47a4-82a9-6e78026e489c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1946-d81d-736a-8874-6369eb3180bb.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sofa, coffee table, and large window.",
        "public_id": "019f1946-d81d-736a-8874-6369eb3180bb",
        "storage_key": "property/6767906449165599/019f1946-d81d-736a-8874-6369eb3180bb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in the comfortable living room, featuring a plush sofa, a stylish coffee table, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Cozy living room with a sofa, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c6a5efa-ab10-4a45-a262-60884ef9c390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1946-d7b2-745c-8d47-db9b0f4b48fa.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, armchair, and sofa.",
        "public_id": "019f1946-d7b2-745c-8d47-db9b0f4b48fa",
        "storage_key": "property/6767906449165599/019f1946-d7b2-745c-8d47-db9b0f4b48fa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center with TV, comfortable armchair, and a stylish sofa, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a fireplace, TV, armchair, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d77a7ba-946d-4e49-954f-39da08c3cda0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1946-d9ac-741e-893f-72b0a95cd4da.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table overlooking a green lawn and trees",
        "public_id": "019f1946-d9ac-741e-893f-72b0a95cd4da",
        "storage_key": "property/6767906449165599/019f1946-d9ac-741e-893f-72b0a95cd4da.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, offering a serene view of the surrounding greenery.",
      "link": "",
      "alt_text": "Balcony with two chairs and a table overlooking a green lawn and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f14a9210-6969-42f3-a36b-07bbcec19993",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-cda7-76ca-a70c-89ecf5f3837a.webp",
      "image_media": {
        "alt_text": "Cozy living room with a brick fireplace, comfortable sofa, coffee table, and an adjacent room visible.",
        "public_id": "019f1940-cda7-76ca-a70c-89ecf5f3837a",
        "storage_key": "property/6767906449165599/019f1940-cda7-76ca-a70c-89ecf5f3837a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in your spacious living room featuring a charming brick fireplace, perfect for cozy evenings. This inviting space offers comfort and a warm ambiance for everyday living and entertaining.",
      "link": "",
      "alt_text": "Cozy living room with a brick fireplace, comfortable sofa, coffee table, and an adjacent room visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7cb99310-f7b5-4d9e-a5e6-53d36932b3b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-8ed9-711a-914e-d0ce312223d4.webp",
      "image_media": {
        "alt_text": "A well-appointed kitchen with white appliances including a stove, microwave, refrigerator, and an adjacent laundry area.",
        "public_id": "019f1940-8ed9-711a-914e-d0ce312223d4",
        "storage_key": "property/6767906449165599/019f1940-8ed9-711a-914e-d0ce312223d4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience modern living with a fully equipped kitchen featuring a stove, microwave, and refrigerator. Enjoy the added convenience of an in-unit washer and dryer in this efficient space.",
      "link": "",
      "alt_text": "A well-appointed kitchen with white appliances including a stove, microwave, refrigerator, and an adjacent laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_792b569c-403d-4e66-86f2-caffd44c415c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-7b49-767d-a101-895b2300a13c.webp",
      "image_media": {
        "alt_text": "Bathroom with light wood vanity, white countertop, large mirror, toilet, and shower with a beige shower curtain.",
        "public_id": "019f1940-7b49-767d-a101-895b2300a13c",
        "storage_key": "property/6767906449165599/019f1940-7b49-767d-a101-895b2300a13c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious light wood vanity with ample storage, a large mirror, and a full-size shower/tub combination with a stylish beige shower curtain, offering comfort and convenience.",
      "link": "",
      "alt_text": "Bathroom with light wood vanity, white countertop, large mirror, toilet, and shower with a beige shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67d7a03b-b5c4-40f8-89d9-c3ead2c0fca0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-d999-706e-b170-7d4b8151cc23.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a plush king-size bed with decorative pillows and a warm-toned duvet. A wooden nightstand with a lamp and artwork adorns the wall.",
        "public_id": "019f1940-d999-706e-b170-7d4b8151cc23",
        "storage_key": "property/6767906449165599/019f1940-d999-706e-b170-7d4b8151cc23.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, complete with a luxurious bed, tasteful decor, and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a plush king-size bed with decorative pillows and a warm-toned duvet. A wooden nightstand with a lamp and artwork adorns the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f9066ee-f8d9-4b5e-badd-33e758592a37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-90f1-73fc-88f2-792050d0fd2a.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and a doorway to the laundry area.",
        "public_id": "019f1940-90f1-73fc-88f2-792050d0fd2a",
        "storage_key": "property/6767906449165599/019f1940-90f1-73fc-88f2-792050d0fd2a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring white appliances, ample cabinet space, and a convenient laundry area. Perfect for everyday living.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and a doorway to the laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5a12344-d11f-486c-8e49-7c0d33206ef4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-b098-7518-a178-7545a85452b9.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with a fireplace, sofa, and dining table.",
        "public_id": "019f1940-b098-7518-a178-7545a85452b9",
        "storage_key": "property/6767906449165599/019f1940-b098-7518-a178-7545a85452b9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious open concept living and dining area featuring a cozy fireplace, comfortable sofa, and elegant dining table, perfect for entertaining.",
      "link": "",
      "alt_text": "Open concept living and dining area with a fireplace, sofa, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6db7d95-6342-426b-bbdd-77ca7f25b4b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-d2b8-72ab-8576-4ce483adc48c.webp",
      "image_media": {
        "alt_text": "Living and dining area in an apartment with a sofa, coffee table, and dining set.",
        "public_id": "019f1940-d2b8-72ab-8576-4ce483adc48c",
        "storage_key": "property/6767906449165599/019f1940-d2b8-72ab-8576-4ce483adc48c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area, perfect for entertaining. Features a comfortable sofa, elegant coffee table, and a formal dining set.",
      "link": "",
      "alt_text": "Living and dining area in an apartment with a sofa, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dadc28fc-164b-44da-bc1b-6b7470691b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-7567-72cb-9ba9-e6991ea2d9f7.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a large bed, two nightstands with lamps, and a window with white sheer curtains.",
        "public_id": "019f1940-7567-72cb-9ba9-e6991ea2d9f7",
        "storage_key": "property/6767906449165599/019f1940-7567-72cb-9ba9-e6991ea2d9f7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in our spacious bedrooms, featuring plush carpeting, elegant window treatments, and ample space for your personal style. Comfortable living awaits.",
      "link": "",
      "alt_text": "A cozy bedroom with a large bed, two nightstands with lamps, and a window with white sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bc7fa84-7362-4e3a-81bc-d0d0fa07eec9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-aeb4-776d-8966-19c5da6f0183.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer",
        "public_id": "019f1940-aeb4-776d-8966-19c5da6f0183",
        "storage_key": "property/6767906449165599/019f1940-aeb4-776d-8966-19c5da6f0183.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "In-unit laundry room with washer and dryer, featuring 'wash' and 'dry' decorative signs.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d15e0d9-6283-450d-9b46-e2c15fdb549e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-811c-775f-97b4-90b526b39132.webp",
      "image_media": {
        "alt_text": "Kitchen with a refrigerator, dishwasher, coffee maker, and double sink.",
        "public_id": "019f1940-811c-775f-97b4-90b526b39132",
        "storage_key": "property/6767906449165599/019f1940-811c-775f-97b4-90b526b39132.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a refrigerator, dishwasher, coffee maker, and a spacious double sink, perfect for everyday use.",
      "link": "",
      "alt_text": "Kitchen with a refrigerator, dishwasher, coffee maker, and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_333f5c0d-7ebb-4825-b528-6615945e6970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-26d4-76c6-bea8-b4e3dd4b8f09.webp",
      "image_media": {
        "alt_text": "Bright bedroom featuring a bed with a pink comforter, wooden headboard, nightstand with a lamp, and two large windows.",
        "public_id": "019f1940-26d4-76c6-bea8-b4e3dd4b8f09",
        "storage_key": "property/6767906449165599/019f1940-26d4-76c6-bea8-b4e3dd4b8f09.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable apartment bedroom, featuring plush carpeting, ample natural light from large windows, and stylish decor including a ceiling fan.",
      "link": "",
      "alt_text": "Bright bedroom featuring a bed with a pink comforter, wooden headboard, nightstand with a lamp, and two large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb2b31cd-86f0-42bc-bcb1-b983ac052b06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-f797-7010-a508-2cd08e858fe0.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs surrounded by pink flowering trees and lush greenery on a sunny day.",
        "public_id": "019f193f-f797-7010-a508-2cd08e858fe0",
        "storage_key": "property/6767906449165599/019f193f-f797-7010-a508-2cd08e858fe0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by our sparkling community pool, a perfect oasis surrounded by vibrant landscaping. Enjoy the sun on comfortable lounge chairs and take a refreshing dip on a beautiful day.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs surrounded by pink flowering trees and lush greenery on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25a31818-556d-4ecb-94c3-37e1e3806237",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-6b98-759c-b18f-8727cde3af8e.webp",
      "image_media": {
        "alt_text": "Interior hallway with view into bedroom and bathroom",
        "public_id": "019f1940-6b98-759c-b18f-8727cde3af8e",
        "storage_key": "property/6767906449165599/019f1940-6b98-759c-b18f-8727cde3af8e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "View down an interior hallway showcasing access to a bedroom and bathroom, with a large closet on the left. This image highlights the functional layout and storage space within the apartment.",
      "link": "",
      "alt_text": "Interior hallway with view into bedroom and bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c31a5782-5ba4-4133-b32c-fee57e0ec66a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-41c8-750c-8295-b4a76d9ea288.webp",
      "image_media": {
        "alt_text": "Clean bathroom with white tile shower, white bathtub, and wooden vanity.",
        "public_id": "019f1940-41c8-750c-8295-b4a76d9ea288",
        "storage_key": "property/6767906449165599/019f1940-41c8-750c-8295-b4a76d9ea288.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this clean and well-maintained bathroom, featuring a refreshing shower and tub combination, and ample vanity space.",
      "link": "",
      "alt_text": "Clean bathroom with white tile shower, white bathtub, and wooden vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_232eaef9-4043-4429-bbee-be55fe9e298a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-49df-7293-913f-002ebf186017.webp",
      "image_media": {
        "alt_text": "Kitchenette with refrigerator, microwave, oven, and small dining table.",
        "public_id": "019f1940-49df-7293-913f-002ebf186017",
        "storage_key": "property/6767906449165599/019f1940-49df-7293-913f-002ebf186017.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy kitchenette featuring modern appliances, ample cabinet space, and a compact dining area perfect for small meals.",
      "link": "",
      "alt_text": "Kitchenette with refrigerator, microwave, oven, and small dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a73c46cf-bc6e-47e4-9619-cc4ac5c217f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-fbe5-73e8-9462-082575470f52.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs, surrounded by lush pink flowering bushes and the property clubhouse under a clear sky.",
        "public_id": "019f193f-fbe5-73e8-9462-082575470f52",
        "storage_key": "property/6767906449165599/019f193f-fbe5-73e8-9462-082575470f52.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind at our sparkling community swimming pool. Enjoy a refreshing dip or lounge poolside on a comfortable chair, surrounded by beautiful landscaping and sunshine. The perfect spot to beat the heat.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs, surrounded by lush pink flowering bushes and the property clubhouse under a clear sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e3e4036-9c3d-4a4a-87c1-a02106342432",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-ad3d-745d-8769-181b1e037651.webp",
      "image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping and a red cube sign.",
        "public_id": "019f193f-ad3d-745d-8769-181b1e037651",
        "storage_key": "property/6767906449165599/019f193f-ad3d-745d-8769-181b1e037651.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Creekwood Apartment Homes, proudly featuring a monument sign and beautiful landscaping.",
      "link": "",
      "alt_text": "Creekwood Apartment Homes monument sign with landscaping and a red cube sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05b4144b-dcd4-45d7-83b0-8657b9dc49f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-f015-729d-9a63-cda7716a8ec4.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with steps and seating area.",
        "public_id": "019f193f-f015-729d-9a63-cda7716a8ec4",
        "storage_key": "property/6767906449165599/019f193f-f015-729d-9a63-cda7716a8ec4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our indoor swimming pool, perfect for year-round relaxation and fun.",
      "link": "",
      "alt_text": "Indoor swimming pool with steps and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbc6f815-6dd7-49d0-9d1e-f133b476bbef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-f01c-757f-b41c-18b4ad7af310.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool area with seating and large windows",
        "public_id": "019f193f-f01c-757f-b41c-18b4ad7af310",
        "storage_key": "property/6767906449165599/019f193f-f01c-757f-b41c-18b4ad7af310.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the indoor swimming pool, a perfect place to relax and unwind. The area features comfortable seating and large windows overlooking the surrounding greenery.",
      "link": "",
      "alt_text": "Indoor swimming pool area with seating and large windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_231b531e-ae95-4053-9e4f-6c90bbba822f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-e3e1-73fc-84ca-b77ada803f41.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer.",
        "public_id": "019f193f-e3e1-73fc-84ca-b77ada803f41",
        "storage_key": "property/6767906449165599/019f193f-e3e1-73fc-84ca-b77ada803f41.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay connected in our business center, equipped with computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and printer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75b33673-0782-48d9-9805-ccd4985f3498",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-ef76-7049-b93c-1044ae960b84.webp",
      "image_media": {
        "alt_text": "Interior of a wooden sauna with benches and a light fixture.",
        "public_id": "019f193f-ef76-7049-b93c-1044ae960b84",
        "storage_key": "property/6767906449165599/019f193f-ef76-7049-b93c-1044ae960b84.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Relax and unwind in our community sauna, a perfect amenity for your well-being.",
      "link": "",
      "alt_text": "Interior of a wooden sauna with benches and a light fixture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_583b896d-3b7a-46c9-a52e-a65195f34e88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-9fa5-74b2-8c59-0c631c14fad5.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, and view into shower/tub area.",
        "public_id": "019f193f-9fa5-74b2-8c59-0c631c14fad5",
        "storage_key": "property/6767906449165599/019f193f-9fa5-74b2-8c59-0c631c14fad5.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a spacious vanity with ample counter space, a sink, and a large mirror. The adjacent shower/tub area is visible, offering a relaxing retreat.",
      "link": "",
      "alt_text": "Bathroom vanity with sink and mirror, and view into shower/tub area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_12b2904e-28da-4748-a871-2da2ee1a7702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-ad3e-7796-986e-4759838bd2ac.webp",
      "image_media": {
        "alt_text": "Exterior view of the main building entrance with brick facade and landscaping.",
        "public_id": "019f193f-ad3e-7796-986e-4759838bd2ac",
        "storage_key": "property/6767906449165599/019f193f-ad3e-7796-986e-4759838bd2ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our community! This image shows the inviting exterior of the main building, featuring a classic brick facade, well-maintained landscaping, and a clear view of the entrance.",
      "link": "",
      "alt_text": "Exterior view of the main building entrance with brick facade and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_66ef2be1-8e11-406d-bd17-768e2e36774d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tasty steaks, ribs, and fried pickles, and the rolls are delicious. They also highlight the affordable prices, lively atmosphere, and attentive service.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0698-7722-a9fc-ea99da1fdf38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0698-7722-a9fc-ea99da1fdf38",
        "storage_key": "property/6767906449165599/019d2709-0698-7722-a9fc-ea99da1fdf38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-39a5-739e-a6a6-2093e1bde0e9",
        "storage_key": "property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_6558db45-1812-41e4-9fa8-0ce5af635e4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a wide variety of delicious food, including pasta, burgers, and cheesecake. They also highlight the attentive and knowledgeable service, and the beautiful, bold decor.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0702-749b-afa3-4bba69bd0596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0702-749b-afa3-4bba69bd0596",
        "storage_key": "property/6767906449165599/019d2709-0702-749b-afa3-4bba69bd0596.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-39a5-739e-a6a6-2093e1bde0e9",
        "storage_key": "property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ac36cf3d-3281-468c-8386-cc15c3ffae82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves hot, fresh, and delicious chicken tenders, and the Cane's sauce is a highlight. They highlight the fast and efficient service, especially in the drive-thru, and the friendly and courteous staff. They also like the fun and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-061a-7028-afd5-51c4e4f9ae37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-061a-7028-afd5-51c4e4f9ae37",
        "storage_key": "property/6767906449165599/019d2709-061a-7028-afd5-51c4e4f9ae37.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-39a5-739e-a6a6-2093e1bde0e9",
        "storage_key": "property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0ead8363-f878-49a6-9450-567f68f8bad7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and grilled chicken bites. They also highlight the friendly, fast, and efficient service, and the clean play area.\n\nSome reviews mention that items can be missing from orders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0655-7266-ab78-e35ec0645df5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0655-7266-ab78-e35ec0645df5",
        "storage_key": "property/6767906449165599/019d2709-0655-7266-ab78-e35ec0645df5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-39a5-739e-a6a6-2093e1bde0e9",
        "storage_key": "property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_010d029f-a33e-4ce3-9320-dddf31db837b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and ribs, with many praising the generous portions and reasonable prices. They also highlight the friendly and attentive service, and the warm and welcoming atmosphere, making it a great choice for families or casual dining.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0b85-736c-9fc1-799109e4649d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0b85-736c-9fc1-799109e4649d",
        "storage_key": "property/6767906449165599/019d2709-0b85-736c-9fc1-799109e4649d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-39a5-739e-a6a6-2093e1bde0e9",
        "storage_key": "property/6767906449165599/019d2709-39a5-739e-a6a6-2093e1bde0e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6a3de344-a60a-41bf-becb-655862c06af0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "2-story enclosed mall with many chain stores & boutiques, plus a kids’ play area & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including a Scheels with a Ferris wheel, and a good food court. They also highlight the clean and safe atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the escalators can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0c1e-735a-96a9-81dcdd0641a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0c1e-735a-96a9-81dcdd0641a5",
        "storage_key": "property/6767906449165599/019d2709-0c1e-735a-96a9-81dcdd0641a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-395f-73cf-8486-1cb84aaeb513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-395f-73cf-8486-1cb84aaeb513",
        "storage_key": "property/6767906449165599/019d2709-395f-73cf-8486-1cb84aaeb513.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9831bfbb-23f9-463c-b50e-97f5dcbcfaf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and a convenient layout. They highlight the clean, spacious, and welcoming atmosphere, as well as the comfortable shoes and delicious cookies. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0c12-72de-b183-71a5a08827cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0c12-72de-b183-71a5a08827cf",
        "storage_key": "property/6767906449165599/019d2709-0c12-72de-b183-71a5a08827cf.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-395f-73cf-8486-1cb84aaeb513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-395f-73cf-8486-1cb84aaeb513",
        "storage_key": "property/6767906449165599/019d2709-395f-73cf-8486-1cb84aaeb513.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f7d8eb73-b0aa-4cb3-a574-e57363b8fcc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meat, and bulk items, including a large selection of candies, spices, and coffee. They highlight the unbeatable prices, especially on chicken and pork, and the convenient 24-hour availability. They also like the clean and well-stocked store, and the friendly and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-0c81-762d-8063-c9a89eef53af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0c81-762d-8063-c9a89eef53af",
        "storage_key": "property/6767906449165599/019d2709-0c81-762d-8063-c9a89eef53af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3976-75f9-ad00-7707b35bc1f6",
        "storage_key": "property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0df34ecb-8095-4e83-896f-b64d4874d1fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a huge variety of fresh produce, seafood, meat, and unique foods from various Asian cultures. They highlight the fair prices, generous portions, and the delicious food at the cafe, including brown sugar milk tea, sushi, and pho. They also like the clean and organized store, and the welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-11a8-70ee-a8d5-e25a2d29f35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-11a8-70ee-a8d5-e25a2d29f35b",
        "storage_key": "property/6767906449165599/019d2709-11a8-70ee-a8d5-e25a2d29f35b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3976-75f9-ad00-7707b35bc1f6",
        "storage_key": "property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_281eb455-9b73-46a7-a301-c1df0cd39f46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy, organic food and fresh produce. They also highlight the clean, organized layout, and the friendly, helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1220-774d-839a-c0cb5b34a41f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1220-774d-839a-c0cb5b34a41f",
        "storage_key": "property/6767906449165599/019d2709-1220-774d-839a-c0cb5b34a41f.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3976-75f9-ad00-7707b35bc1f6",
        "storage_key": "property/6767906449165599/019d2709-3976-75f9-ad00-7707b35bc1f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b68d54e4-e2c4-42a5-a4b1-47c0d78b68df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-11a9-7736-becd-9a879bd5e037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-11a9-7736-becd-9a879bd5e037",
        "storage_key": "property/6767906449165599/019d2709-11a9-7736-becd-9a879bd5e037.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-391c-71c9-9ea8-74d0149be438",
        "storage_key": "property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bee5a929-77f8-44ef-82a7-f0d7517c8932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1225-7603-85d7-2b9a7d6ba8f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1225-7603-85d7-2b9a7d6ba8f2",
        "storage_key": "property/6767906449165599/019d2709-1225-7603-85d7-2b9a7d6ba8f2.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-391c-71c9-9ea8-74d0149be438",
        "storage_key": "property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0689e2e4-edd7-4cef-8c2c-abc4283f9449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Entertainment",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide variety of books and engaging programs for all ages, including story time for infants and toddlers. They highlight the spacious and beautiful environment, with comfortable seating and study rooms, and the helpful staff. They also like the dedicated kids' area with board books and activities, and the clean bathrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-163e-7614-b27e-894b4de23f48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-163e-7614-b27e-894b4de23f48",
        "storage_key": "property/6767906449165599/019d2709-163e-7614-b27e-894b4de23f48.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-391c-71c9-9ea8-74d0149be438",
        "storage_key": "property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ab42df7a-fdcb-4bef-835a-db053ead4920",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1700-75d9-94e5-ce3cdebab0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1700-75d9-94e5-ce3cdebab0dd",
        "storage_key": "property/6767906449165599/019d2709-1700-75d9-94e5-ce3cdebab0dd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-391c-71c9-9ea8-74d0149be438",
        "storage_key": "property/6767906449165599/019d2709-391c-71c9-9ea8-74d0149be438.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4c15a061-542e-4c17-b271-6ad790bd11f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1784-7797-a371-ed8320c969be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1784-7797-a371-ed8320c969be",
        "storage_key": "property/6767906449165599/019d2709-1784-7797-a371-ed8320c969be.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_cee6eea9-8b9c-4603-ba2d-abef8c425b42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides for all ages, including a dedicated area for younger children. They highlight the exciting rides, the fun atmosphere for families and groups, and the opportunity for kids to get exercise. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1800-70d1-a95b-2bf48c8689e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1800-70d1-a95b-2bf48c8689e5",
        "storage_key": "property/6767906449165599/019d2709-1800-70d1-a95b-2bf48c8689e5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_e6a6df5c-46df-41c1-8cfd-814dff5845bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_long_description": "People say this arena offers comfortable seating and good views for events, including concerts and sporting events. They highlight the venue is clean, family-friendly, and has plenty of parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1b5a-704b-9577-a2e9ce172700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1b5a-704b-9577-a2e9ce172700",
        "storage_key": "property/6767906449165599/019d2709-1b5a-704b-9577-a2e9ce172700.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_530e109e-64a2-40a7-8499-9799e28581f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, and virtual reality. They also highlight the helpful and patient staff, and the fun experience for birthday parties.\n\nOther reviews mention the food can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1ba7-7019-8022-aea64bd3c01b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1ba7-7019-8022-aea64bd3c01b",
        "storage_key": "property/6767906449165599/019d2709-1ba7-7019-8022-aea64bd3c01b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_4b3d1e39-cf5d-46ff-bf40-f2fb18b0f09f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1cc0-77d9-96b2-6d367e8425ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1cc0-77d9-96b2-6d367e8425ed",
        "storage_key": "property/6767906449165599/019d2709-1cc0-77d9-96b2-6d367e8425ed.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_80c2da8c-46b2-4192-b0b8-d6b9e5c7723d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, classes, and pool programs, and has a playroom for children.\n\nOther reviews mention the facilities can be crowded and the management can be unresponsive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-1c16-758c-9c36-681ac8a1ea2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1c16-758c-9c36-681ac8a1ea2f",
        "storage_key": "property/6767906449165599/019d2709-1c16-758c-9c36-681ac8a1ea2f.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_79130ad0-a138-44b1-b497-96e172a7d94a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and personal training, and the staff is friendly and helpful.\n\nOther reviews mention the cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2160-7294-afe2-13b1bfbe9e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2160-7294-afe2-13b1bfbe9e36",
        "storage_key": "property/6767906449165599/019d2709-2160-7294-afe2-13b1bfbe9e36.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bf8ecfee-bbec-4b4d-a4d2-eb2fae8f800e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2060-744c-83f5-0316cc63f9f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2060-744c-83f5-0316cc63f9f1",
        "storage_key": "property/6767906449165599/019d2709-2060-744c-83f5-0316cc63f9f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_333afcae-0586-4c34-92f2-d73ebd3a71ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "People say this gym offers a clean and comfortable environment with friendly and helpful staff. They also highlight the welcoming and judgement-free atmosphere, making it a great place for all fitness levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-21b1-763a-baf3-9ccd16abb25b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-21b1-763a-baf3-9ccd16abb25b",
        "storage_key": "property/6767906449165599/019d2709-21b1-763a-baf3-9ccd16abb25b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f50f276a-6c78-4385-993c-aba8a083aa0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7990 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities, and classes, including yoga, HIIT, and aqua classes. They also highlight the motivating atmosphere, the knowledgeable and supportive instructors, and the friendly community.\n\nSome reviews mention there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2199-7360-9288-d7cf962011ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2199-7360-9288-d7cf962011ae",
        "storage_key": "property/6767906449165599/019d2709-2199-7360-9288-d7cf962011ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/tulsa/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684131092404226149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "36.0885483",
      "poi_longitude": "-95.8878289",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-984-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXRVgW-NtocRZcjZx1JfJqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_299e8c9f-19c7-403e-8055-be32a96ea35a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and amenities, including a pool, hot tub, sauna, and steam room. They highlight the affordable membership price and the clean, well-maintained facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2540-744f-8bed-265b619874cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2540-744f-8bed-265b619874cd",
        "storage_key": "property/6767906449165599/019d2709-2540-744f-8bed-265b619874cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_354d7930-3fbe-4878-809e-26988bb9997d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-27d2-756b-bb70-ec0abcfe77fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-27d2-756b-bb70-ec0abcfe77fb",
        "storage_key": "property/6767906449165599/019d2709-27d2-756b-bb70-ec0abcfe77fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d1a-725b-9945-38e81ab469fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d1a-725b-9945-38e81ab469fc",
        "storage_key": "property/6767906449165599/019d2709-3d1a-725b-9945-38e81ab469fc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_28b74e74-4e51-453a-bb99-6a530a2f9322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Saint Francis Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "10501 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-262e-73e2-a048-7a94034efa8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-262e-73e2-a048-7a94034efa8a",
        "storage_key": "property/6767906449165599/019d2709-262e-73e2-a048-7a94034efa8a.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406794313894727694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital-south",
      "poi_latitude": "36.0333434",
      "poi_longitude": "-95.8576667",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d1a-725b-9945-38e81ab469fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d1a-725b-9945-38e81ab469fc",
        "storage_key": "property/6767906449165599/019d2709-3d1a-725b-9945-38e81ab469fc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXaxi3-OtocRDhBgtecRcv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_73c8d276-348c-43ec-8a1a-065057ff26c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1205 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a spectacular Christmas light display with millions of lights, synchronized music, and fun add-ons like a train ride and concession stands. They highlight the festive, joyful, and magical atmosphere, and the family-friendly experience. They also like the free admission and easy parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-27f6-7298-9f66-a733c61e1be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-27f6-7298-9f66-a733c61e1be2",
        "storage_key": "property/6767906449165599/019d2709-27f6-7298-9f66-a733c61e1be2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d60-7032-aa20-05908bbeb314",
        "storage_key": "property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_04ba89bd-44c2-45a0-bf36-79244c21744a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Large city park with ample facilities including sports fields & courts, a pool, playgrounds & golf.",
      "poi_long_description": "People say this park offers a golf course, driving range, playgrounds, and walking trails. They highlight the clean and well-maintained facilities, and the safe and family-friendly atmosphere. They also like the ample parking and covered picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2aab-770b-bc07-b096632b11cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2aab-770b-bc07-b096632b11cb",
        "storage_key": "property/6767906449165599/019d2709-2aab-770b-bc07-b096632b11cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d60-7032-aa20-05908bbeb314",
        "storage_key": "property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_55331a9a-3b39-429c-a3a4-28c40febe38b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including swings, slides, and climbing structures, as well as picnic tables and benches. They highlight the park's accessibility, shade, and fenced-in area, which provides a safe and fun environment for children of all ages. They also like the clean bathrooms, water fountain with bottle refill station, and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2b31-73ef-af29-3b33c4454661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2b31-73ef-af29-3b33c4454661",
        "storage_key": "property/6767906449165599/019d2709-2b31-73ef-af29-3b33c4454661.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d60-7032-aa20-05908bbeb314",
        "storage_key": "property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6eea61a1-7b4c-483f-b2e9-255a13253a12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Vast county park boasting picnic area & playgrounds, plus an 18-hole championship disc golf course.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, disc golf, hiking trails, and picnic areas. They highlight the spacious layout, clean facilities, and well-maintained grounds. They also like the shaded areas and the peaceful, natural atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2c9e-7289-a2e8-d2375335079a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2c9e-7289-a2e8-d2375335079a",
        "storage_key": "property/6767906449165599/019d2709-2c9e-7289-a2e8-d2375335079a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d60-7032-aa20-05908bbeb314",
        "storage_key": "property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d7983f46-3326-4e07-9a5a-ea860ca52fc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Large space featuring a dog park & small pond, plus trails for walking & biking.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2d2a-706b-8b48-2a80d0157d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2d2a-706b-8b48-2a80d0157d5b",
        "storage_key": "property/6767906449165599/019d2709-2d2a-706b-8b48-2a80d0157d5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d60-7032-aa20-05908bbeb314",
        "storage_key": "property/6767906449165599/019d2709-3d60-7032-aa20-05908bbeb314.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a9a7961f-4953-4c7b-9d70-8fe5247fc909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-2f08-748f-a660-92b30c413742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2f08-748f-a660-92b30c413742",
        "storage_key": "property/6767906449165599/019d2709-2f08-748f-a660-92b30c413742.webp",
        "width": 1280,
        "height": 1034
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3e21-743a-99df-bc65796e48bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3e21-743a-99df-bc65796e48bf",
        "storage_key": "property/6767906449165599/019d2709-3e21-743a-99df-bc65796e48bf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c5ca8d06-18b8-4a39-854b-bb403444af3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-301e-74de-b30e-f9d00f417348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-301e-74de-b30e-f9d00f417348",
        "storage_key": "property/6767906449165599/019d2709-301e-74de-b30e-f9d00f417348.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3e21-743a-99df-bc65796e48bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3e21-743a-99df-bc65796e48bf",
        "storage_key": "property/6767906449165599/019d2709-3e21-743a-99df-bc65796e48bf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ff3b40e7-8ff3-4f6d-a1b6-ce08ab32c3e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-314a-71a9-8f17-fba99c7abd0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-314a-71a9-8f17-fba99c7abd0e",
        "storage_key": "property/6767906449165599/019d2709-314a-71a9-8f17-fba99c7abd0e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2e09cac3-10bb-498f-8e95-a71dc8d7c8f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3225-775e-b9fe-18183c460fde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3225-775e-b9fe-18183c460fde",
        "storage_key": "property/6767906449165599/019d2709-3225-775e-b9fe-18183c460fde.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_49d12a75-a487-42cc-adbf-048000fb192d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3512-7067-aed3-57cab0739493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3512-7067-aed3-57cab0739493",
        "storage_key": "property/6767906449165599/019d2709-3512-7067-aed3-57cab0739493.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f38a557e-25dc-41dd-903e-63924685af80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3474-773e-8e64-2f0d4cbb18e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3474-773e-8e64-2f0d4cbb18e7",
        "storage_key": "property/6767906449165599/019d2709-3474-773e-8e64-2f0d4cbb18e7.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4055280a-324d-4512-a81d-3078e6580cfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3d3e-71c7-963c-b0c170d44fd0",
        "storage_key": "property/6767906449165599/019d2709-3d3e-71c7-963c-b0c170d44fd0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bf460c1c-9ab5-4cb7-850a-13679c16e4fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Jarman Elementary School",
      "poi_type": "Education",
      "poi_address": "9015 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://unionps.org/index.php?pageID=426682_3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163329848068604185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jarman-elementary-school",
      "poi_latitude": "36.0504608",
      "poi_longitude": "-95.8761305",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6547b0d2853d",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-clnx8GNtocRGQE1dij4btI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_101aa1c1-d4a4-4135-b4e7-024c940dae3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-21c7-7668-93ec-0a9fabe7f6dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-21c7-7668-93ec-0a9fabe7f6dd",
        "storage_key": "property/6767906449165599/019d7912-21c7-7668-93ec-0a9fabe7f6dd.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6547b0d2853d",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e50acc68-3383-4cff-8887-6ac40c6007e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-21c6-7165-9a7f-7c6a91880064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-21c6-7165-9a7f-7c6a91880064",
        "storage_key": "property/6767906449165599/019d7912-21c6-7165-9a7f-7c6a91880064.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6547b0d2853d",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_362bfc8c-fb3a-4b74-baf6-6a4dae073f53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-21f1-76bc-81a1-c26d39da5f30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-21f1-76bc-81a1-c26d39da5f30",
        "storage_key": "property/6767906449165599/019d7912-21f1-76bc-81a1-c26d39da5f30.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6547b0d2853d",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_60bc95a4-834d-4959-b3d0-57312641b61e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Union High School Freshman Academy",
      "poi_type": "Education",
      "poi_address": "7616 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-21e2-7035-b9ff-45ae7938e28b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-21e2-7035-b9ff-45ae7938e28b",
        "storage_key": "property/6767906449165599/019d7912-21e2-7035-b9ff-45ae7938e28b.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://ufa.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11673188432274153300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-freshman-academy",
      "poi_latitude": "36.0524715",
      "poi_longitude": "-95.8526699",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-357-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6547b0d2853d",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6547b0d2853d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSlfnDaMtocRVF_mLQh__6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_359ea919-c147-4f4c-a9d3-12ea98c94aaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "The Big Biscuit",
      "poi_type": "Restaurants",
      "poi_address": "8920 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual cafe serving pancakes and waffles for breakfast, lunch and brunch, with biscuits also on the menu.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits, biscuits and gravy, chicken fried steak, and waffles. They highlight the large portions, quick service, and attentive staff. They also like the friendly staff and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-27e7-7053-a418-28de1774ebc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-27e7-7053-a418-28de1774ebc2",
        "storage_key": "property/6767906449165599/019d7912-27e7-7053-a418-28de1774ebc2.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://bigbiscuit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15812448215389890625&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-big-biscuit",
      "poi_latitude": "36.0337674",
      "poi_longitude": "-95.8872532",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-957-5163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXbuOl2NtocRQeiSu98Zcds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_25228db5-cc81-471c-85d2-76f757943b51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Oliveto Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "8922 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Local Italian chain serving pasta, pizza, sandwiches, classic entrees & wine in a stylish space.",
      "poi_long_description": "People say this Italian restaurant serves delicious chicken parmesan, pizza, and bruschetta. They also highlight the friendly staff and attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-2a99-70d7-a766-63ed54a38cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2a99-70d7-a766-63ed54a38cd8",
        "storage_key": "property/6767906449165599/019d7912-2a99-70d7-a766-63ed54a38cd8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.olivetobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5883500537200521972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oliveto-italian-bistro",
      "poi_latitude": "36.034014",
      "poi_longitude": "-95.8871088",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-994-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUw9-xuKNtocR9DKoA5FkplE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a7935929-9b54-4cd2-916b-32980afc08fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Char Char",
      "poi_type": "Restaurants",
      "poi_address": "6560 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Unpretentious, family-owned eatery offering organic options such as kabob platters and gyros.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious chicken kabobs, gyros, and gyro platters, and fresh tabouli and hummus. They highlight the generous portions, flavorful food, and the friendly, welcoming atmosphere. They also like the attentive service and the kind, engaging management.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-2ab9-74cb-8128-3f3a2743b176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2ab9-74cb-8128-3f3a2743b176",
        "storage_key": "property/6767906449165599/019d7912-2ab9-74cb-8128-3f3a2743b176.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tulsacharchar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17702276239936026694&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "char-char",
      "poi_latitude": "36.0315319",
      "poi_longitude": "-95.9024514",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-398-6053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSJg3gGStocRRng5FXMeq_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_66b507b3-7641-41c6-8802-198160545864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Le Louvre French Cafe",
      "poi_type": "Restaurants",
      "poi_address": "8313 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual, cozy, Parisian-inspired restaurant serving freshly prepared French pastries, croissants, crêpes and quiches, plus omelettes and other staples, alongside coffee.",
      "poi_long_description": "People say this French restaurant offers delicious crepes, quiche, pastries, and coffee. They highlight the authentic Parisian vibe and the generous portions. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-2c14-7368-92dd-6cee87673fdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2c14-7368-92dd-6cee87673fdd",
        "storage_key": "property/6767906449165599/019d7912-2c14-7368-92dd-6cee87673fdd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://lelouvrefrenchcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3580839522789357152&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "le-louvre-french-cafe",
      "poi_latitude": "36.0436267",
      "poi_longitude": "-95.8855895",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-286-6019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWzDEXCNtocRYPaJ6ZKysTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_74f2b30a-03f4-49b6-aafd-f61b6f9beae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "El Tequila Mexican Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "8118 S Memorial Dr STE A, Tulsa, OK 74133, USA",
      "poi_short_description": "Local chain serving a menu of traditional Mexican dishes & margaritas in a casual setting.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, enchiladas, and street corn. They also highlight the fast and friendly service, and the good value.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-33c1-70af-800b-e0e59c4e53a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-33c1-70af-800b-e0e59c4e53a8",
        "storage_key": "property/6767906449165599/019d7912-33c1-70af-800b-e0e59c4e53a8.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://eltequilaok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17599433970458926058&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-tequila-mexican-kitchen",
      "poi_latitude": "36.0459266",
      "poi_longitude": "-95.8875356",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-459-7677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzm8se-NtocR6pslSfO_PfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7ae1a705-2ad1-471e-862f-ed5be1e77fe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Brook South",
      "poi_type": "Restaurants",
      "poi_address": "7727 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly sports bar dishing up classics including burgers, sandwiches, soups & salads.",
      "poi_long_description": "People say this American restaurant serves generous portions of fish and chips, cheeseburgers, and chicken fried steak. They also highlight the friendly staff, reasonable prices, and pub-like atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-363a-713a-b1fd-ba7a8692a3ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-363a-713a-b1fd-ba7a8692a3ac",
        "storage_key": "property/6767906449165599/019d7912-363a-713a-b1fd-ba7a8692a3ac.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.brookrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13481161506126313612&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brook-south",
      "poi_latitude": "36.0323371",
      "poi_longitude": "-95.8887621",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-392-9977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzx_i9weOtocRjDhUrPa0Frs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_35f62c0b-6f20-473c-8cf5-fa78790b5be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Black Bear Diner Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "9026 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "People say this restaurant serves delicious pancakes, burgers, and bacon. They also highlight the generous portions, affordable prices, and family-friendly atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-38d8-74ae-a44b-f7ae0f519011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-38d8-74ae-a44b-f7ae0f519011",
        "storage_key": "property/6767906449165599/019d7912-38d8-74ae-a44b-f7ae0f519011.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8977697759841423897&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-tulsa",
      "poi_latitude": "36.0604657",
      "poi_longitude": "-95.8764064",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-459-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Qxwi-qNtocRGRIr9Iswl3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a457b423-42d3-4f87-b987-e82ff680c1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "4651 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious Bang Bang shrimp, Imperial Cod, and Brussels sprouts. They highlight the excellent service, welcoming atmosphere, and tasty complimentary bread. They also like the attentive staff and the perfect music for the occasion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-3a83-72fe-8840-12538423e89a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a83-72fe-8840-12538423e89a",
        "storage_key": "property/6767906449165599/019d7912-3a83-72fe-8840-12538423e89a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/oklahoma/broken-arrow/4651-w.-kenosha-street?y_source=1_MTU1MDI2OTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11058823268018440839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.059982",
      "poi_longitude": "-95.8478642",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-252-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wz1zUiMtocRh0oQjCvVeJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_969e1fd4-b53c-44e1-b822-9437264c8548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "8722 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Offshoot of the retailer offering designer deals on apparel, shoes and accessories for men and women.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, shoes, and accessories, including designer brands. They also highlight the great deals and discounts, and the clean, well-organized store.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-3fee-71de-a1a1-e825272d08ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3fee-71de-a1a1-e825272d08ec",
        "storage_key": "property/6767906449165599/019d7912-3fee-71de-a1a1-e825272d08ec.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/ok/tulsa/8722-east-71st-st?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=749&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=13757998200129437977&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "36.05902620000001",
      "poi_longitude": "-95.87937",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-505-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn6CWZ5aNtocRGcEtU3g67r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_48af9a27-8e6e-4823-aa67-a0ef3f9a92c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Amini's Galleria",
      "poi_type": "Shopping & Retail",
      "poi_address": "7712 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Outdoor furniture specialist offering pool tables, arcade-style video games and rugs.",
      "poi_long_description": "People say this furniture store offers a wide variety of items, including outdoor furniture, fireplaces, and arcade games. They highlight the incredible sales and the knowledgeable, low-pressure sales staff. They also like the prompt service and helpfulness of the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-4236-770b-87cf-0c123e0be37d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4236-770b-87cf-0c123e0be37d",
        "storage_key": "property/6767906449165599/019d7912-4236-770b-87cf-0c123e0be37d.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.aminis.com/tulsa.inc?utm_source=g-local&utm_medium=organic&utm_campaign=GMBTulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3138316433275490263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amini-s-galleria",
      "poi_latitude": "36.0602581",
      "poi_longitude": "-95.8903144",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-254-6444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtRAcZ46NtocR1w8oJiuKjSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_96b86bbe-9e8e-4c71-8cd2-b84c807ad958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6625 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer stocking toys, clothing, electronics, home goods, furniture, groceries and more.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, clothing, and household items. They also highlight the convenient one-stop shopping experience and the affordable prices.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-4862-730c-bba1-357a5031a3fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4862-730c-bba1-357a5031a3fc",
        "storage_key": "property/6767906449165599/019d7912-4862-730c-bba1-357a5031a3fc.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/894-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18164824787754373520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0674096",
      "poi_longitude": "-95.8830124",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-294-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjfQHJZqNtocRkFFPMedrFvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1796868a-4ed1-4f5c-83c3-ed0627a33304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8207 E 103rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of products, including imported foods, seasonal items, and chocolates. They highlight the good prices and the friendly, helpful staff. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-4d18-745a-a9b4-014862bbb254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4d18-745a-a9b4-014862bbb254",
        "storage_key": "property/6767906449165599/019d7912-4d18-745a-a9b4-014862bbb254.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/tulsa/8207-e-103rd-street/f273",
      "poi_directions_map_url": "https://maps.google.com/?cid=1388118032718245033&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.014595",
      "poi_longitude": "-95.884268",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f9e-77c8-a058-6b0db996d9e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f9e-77c8-a058-6b0db996d9e3",
        "storage_key": "property/6767906449165599/019cfb3e-0f9e-77c8-a058-6b0db996d9e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk21FUVGOtocRqSx8Bv-VQxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b9e14d4b-9c17-4650-86e2-65c8ddbe1b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "7030 Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain specializing in clothing, handbags and shoes, plus home goods.",
      "poi_long_description": "People say this clothing store offers a wide selection of clothing and great deals.\n\nOther reviews mention the lines can be long and the wait times can be excessive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-4b31-755f-a489-d7e24fb235d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4b31-755f-a489-d7e24fb235d1",
        "storage_key": "property/6767906449165599/019d7912-4b31-755f-a489-d7e24fb235d1.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/ok/tulsa/55/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5885468057467039918&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "36.0624008",
      "poi_longitude": "-95.8891372",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-5533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZf6O04-NtocRrjA7BgRirVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f60a52a8-23c5-4569-a706-6141be75dd9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6922 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of products and good prices. They also highlight the friendly staff and convenient bulk shopping.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-4d25-75cb-9176-c3fa97c2f0ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4d25-75cb-9176-c3fa97c2f0ca",
        "storage_key": "property/6767906449165599/019d7912-4d25-75cb-9176-c3fa97c2f0ca.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/6342-tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=2142616615335699436&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "36.0628489",
      "poi_longitude": "-95.8716547",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-252-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxq7n7uNtocR7CPvpnUavB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3e2a171c-05b8-4d2e-a350-66ead9f79c25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "9717 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of products for hobbies and decorating, including yarn, fabric, and seasonal decorations. They highlight the good prices and the clean, organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-536b-732d-b143-35b1cd543dc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-536b-732d-b143-35b1cd543dc7",
        "storage_key": "property/6767906449165599/019d7912-536b-732d-b143-35b1cd543dc7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/3",
      "poi_directions_map_url": "https://maps.google.com/?cid=5139651924585796964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "36.0639533",
      "poi_longitude": "-95.8669013",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-254-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVS6DnLqNtocRZNUWwjG2U0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_78112e8b-cfc6-42d0-aabf-dff3d398b243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Harbor Freight",
      "poi_type": "Shopping & Retail",
      "poi_address": "9137 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_long_description": "Shoppers say this hardware store offers great deals on tools and is a convenient place to find what you need. They also highlight the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-5567-7356-81fa-1002e460f125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5567-7356-81fa-1002e460f125",
        "storage_key": "property/6767906449165599/019d7912-5567-7356-81fa-1002e460f125.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.harborfreight.com/storelocator/9137-e-71st-street-tulsa-74133?number=3195",
      "poi_directions_map_url": "https://maps.google.com/?cid=9632679527952691421&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harbor-freight",
      "poi_latitude": "36.0623049",
      "poi_longitude": "-95.8740904",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-524-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-582e60050401",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-582e60050401.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKdXRwpmNtocR3TDMmv4mroU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_689adfda-b106-4f57-9059-2c57faf4148c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Leake Park",
      "poi_type": "Entertainment",
      "poi_address": "7714 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-643e-762b-92f0-d41c2b229bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-643e-762b-92f0-d41c2b229bff",
        "storage_key": "property/6767906449165599/019d7912-643e-762b-92f0-d41c2b229bff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/government/departments/park-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15363708563321327691&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "leake-park",
      "poi_latitude": "36.0576247",
      "poi_longitude": "-95.88987240000002",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-596-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f92-70cd-99dd-aff6d69c307e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f92-70cd-99dd-aff6d69c307e",
        "storage_key": "property/6767906449165599/019cfb3e-0f92-70cd-99dd-aff6d69c307e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTqelI2NtocRSxBltYnbNtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_06e3fb65-de38-4471-9976-47e807568689",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa’s Incredible Food and Fun",
      "poi_type": "Entertainment",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Popular place for parties offering go-karts, rides, games & pizza with an all-you-can-eat buffet.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including pizza, hot dogs, tacos, and a salad bar, and has fun games and attractions like laser tag, bumper cars, and a roller coaster. They also highlight the fun, family-friendly atmosphere and the helpful, friendly staff.\n\nOther reviews mention some games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-5eac-772a-9014-deb238c5e65c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5eac-772a-9014-deb238c5e65c",
        "storage_key": "property/6767906449165599/019d7912-5eac-772a-9014-deb238c5e65c.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblefoodandfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-s-incredible-food-and-fun",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f91-7054-aa16-5c964b2824bc",
        "storage_key": "property/6767906449165599/019cfb3e-0f91-7054-aa16-5c964b2824bc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_e2e457f8-5f48-428a-93bf-582fd17a9886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Cinergy Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6808 S Memorial Dr Suite #300, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain for games, bowling and escape rooms, plus reclining seats and food service.",
      "poi_long_description": "People say this movie theater offers a variety of entertainment options, including axe throwing, bowling, and escape rooms. They also highlight the comfortable, reclining, and heated seats in the theaters, and the fun, exciting, and family-friendly atmosphere.\n\nOther reviews mention the escape rooms can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-5e54-77b3-b791-4b17f69e2810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5e54-77b3-b791-4b17f69e2810",
        "storage_key": "property/6767906449165599/019d7912-5e54-77b3-b791-4b17f69e2810.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cinergy.com/tulsa?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12585207871385463090&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinergy-tulsa",
      "poi_latitude": "36.0641679",
      "poi_longitude": "-95.8891144",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-894-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-8581-76cd-a100-368984b77065.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-8581-76cd-a100-368984b77065",
        "storage_key": "property/6767906449165599/019d7912-8581-76cd-a100-368984b77065.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXifiyGNtocRMmlhNuGjp64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2a79fd57-466d-411e-9515-ec5abb58525b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-615d-723b-a913-9b23f96782f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-615d-723b-a913-9b23f96782f5",
        "storage_key": "property/6767906449165599/019d7912-615d-723b-a913-9b23f96782f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0fbc-73a0-9472-d652eea8a1bf",
        "storage_key": "property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_b5dfdd92-110c-4970-a15f-619f425f9a6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Andy B's - Tulsa, OK",
      "poi_type": "Entertainment",
      "poi_address": "8711 S Lewis Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Family-friendly complex with bowling, laser tag, go-karts & games plus American eats & a pro shop.",
      "poi_long_description": "Visitors say this bowling alley offers a wide variety of entertainment options, including go-karts, laser tag, an arcade, and escape rooms. They also highlight the friendly and helpful staff, the clean environment, and the fun atmosphere for families and groups.\n\nSome reviews mention the wait times for go-karts can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-66a2-711c-bf48-b9efb9c88fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-66a2-711c-bf48-b9efb9c88fab",
        "storage_key": "property/6767906449165599/019d7912-66a2-711c-bf48-b9efb9c88fab.webp",
        "width": 820,
        "height": 462
      },
      "poi_business_url": "https://bowlandybs.com/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=1068490842134744562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andy-b-s-tulsa-ok",
      "poi_latitude": "36.0379181",
      "poi_longitude": "-95.9540939",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-299-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0fbc-73a0-9472-d652eea8a1bf",
        "storage_key": "property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx__1HtuTtocR8g0zg8IK1A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_cfa9fd8e-26b1-4e4d-bdea-9c8b6070afd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa Air and Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "3624 N 74th E Ave, Tulsa, OK 74115, USA",
      "poi_short_description": "Detailed history from 1897 to the space age plus interactive exhibits, vintage aircraft & a theater.",
      "poi_long_description": "People say this museum offers a variety of aircraft, interactive exhibits, and a planetarium. They also highlight the friendly and helpful staff, and the affordable admission.\n\nOther reviews mention some exhibits can be under repair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-6bc8-7427-b221-d64efb42ed20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6bc8-7427-b221-d64efb42ed20",
        "storage_key": "property/6767906449165599/019d7912-6bc8-7427-b221-d64efb42ed20.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tulsamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16931592180727714246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-air-and-space-museum",
      "poi_latitude": "36.2067509",
      "poi_longitude": "-95.8957281",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-834-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-85f7-702c-9464-22fa8bdb177b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-85f7-702c-9464-22fa8bdb177b",
        "storage_key": "property/6767906449165599/019d7912-85f7-702c-9464-22fa8bdb177b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9UUGf_xtocRxpEOhmEZ-eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_667b8ded-3b58-48e8-808f-43700ff5db76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019d7912-6fbf-756c-a0b4-69a7e3b6c3d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6fbf-756c-a0b4-69a7e3b6c3d6",
        "storage_key": "property/6767906449165599/019d7912-6fbf-756c-a0b4-69a7e3b6c3d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "13.3",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0fbc-73a0-9472-d652eea8a1bf",
        "storage_key": "property/6767906449165599/019cfb3e-0fbc-73a0-9472-d652eea8a1bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_e3ae80fe-aa02-4ea4-9f80-cf7232dd0be1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Regent Preparatory Academy (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-academy-grades-pre-k-through-12",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_639cdd48-df1e-41fe-81d0-741be744dd46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14ec5759-2cae-460f-989c-db45588565b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park featuring an adventure playground, a sensory garden, a picnic area, eateries & more.",
      "poi_long_description": "People say this park offers an extensive variety of unique play areas and activities for all ages, including free kayak and paddleboat rentals. Visitors also highlight the beautiful, well-maintained grounds and clean restrooms. They appreciate the free entry and ample parking, making it a great value for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019e18ca-8c7d-75dd-9e5a-e787d49e3964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e18ca-8c7d-75dd-9e5a-e787d49e3964",
        "storage_key": "property/6767906449165599/019e18ca-8c7d-75dd-9e5a-e787d49e3964.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-0f92-70cd-99dd-aff6d69c307e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3e-0f92-70cd-99dd-aff6d69c307e",
        "storage_key": "property/6767906449165599/019cfb3e-0f92-70cd-99dd-aff6d69c307e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_be1b7cb74b9822e6311ef953",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_57619406d559cf594aab13fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_41084f7b472f21401976ae8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d204368df56056eaa92453ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_59a48e8b56d223ff356c6b82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_aed08a383000dee4ea24fa90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_f38a8aff-1362-444f-bed8-f03018f95fb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "rating": "5.0",
      "name": "Kortney Harris",
      "text": "I have lived here for almost 2 years, I don't have many bad things at all to say about these apartments. They have been the best I have lived at in a LONG time. The neighbors are very nice and have helped me several times with various things when they didn't even know me. Office management has always worked with me and appreciated open communication. All of them are the nicest people. Everyone's dog is pretty tame and I have no complaints about any dog noises, sometimes I forget they are here too. The gym and pools are nice and I enjoy them. Overall, if you are looking for a decent apartment for the price, they won't disappoint!",
      "date": "2025-09-30",
      "title": ""
    },
    {
      "id": "custom_b4b30ac0-da5e-409f-b66c-db56fadcbe31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "rating": "5.0",
      "name": "Fairly Odd",
      "text": "Moved in on Sunday. The railing wasn’t fun or the ice but over all everything went well. Oayis (I know I spelled it wrong. Tried to find a staff directory) made the entire experience amazing. That guy goes above and beyond for his applicants.",
      "date": "2026-02-03",
      "title": ""
    },
    {
      "id": "custom_7aaab347-1ac7-4a90-acf1-bf9333233363",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "rating": "5.0",
      "name": "Nicole Hurd",
      "text": "I love it here so far! Maintenance is fast. The office workers are kind and helpful. Neighbors are surprisingly quiet. They have a ceiling fan in the bedroom! Would highly recommend!",
      "date": "2025-12-15",
      "title": ""
    },
    {
      "id": "custom_cdab823e-6bc5-45c7-b50d-afc8a81b75e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "rating": "5.0",
      "name": "Stephanie Van Maren",
      "text": "Best apartments I’ve ever lived at. All staff members are so friendly and helpful. Very beautiful complex and I’ve never had any issues or safety concerns. Anytime I’ve noticed something needing fixed, it’s usually either within a few hours or next day. They don’t cut corners either, if they can’t fix something properly they will replace it. I had a door that was had issues with the hinges and they replaced it. Our ceiling fan wobbled and they replaced it. When I reported seeing spiders they got someone to come spray. Appliances and very nice and new. Washer and dryer are very nice and big. Worth every penny to live here.",
      "date": "2025-07-31",
      "title": ""
    },
    {
      "id": "custom_b912959a-fe65-4941-90dd-a67748fe7e1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "rating": "5.0",
      "name": "tomi w",
      "text": "I have lived here 2 separate times now and can assure anyone reading this review that is the best (affordable) complex for its location. The maintenance is great. They have always come the same day and been able to resolve our request by the next day. The office staff is very friendly and helpful. They keep up the outside very well. It’s always mowed, trash is picked up, pools and facilities are always clean. 5 stars",
      "date": "2025-07-23",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e2dc71f9-a84a-436e-b5bf-18fb54867e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-8848-71d1-a512-21436172b7e4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of the outdoor swimming pool area with lounge chairs and tables.",
        "public_id": "019cfb3e-8848-71d1-a512-21436172b7e4",
        "storage_key": "property/6767906449165599/019cfb3e-8848-71d1-a512-21436172b7e4.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Creekwood Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f770471c021d22418c68f97&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-2a95-7649-83d3-f33abc19ac4c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "creekwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599"
    },
    {
      "lead_collector_id": "019cf79e-2b09-729e-a36d-2a6111e271c6",
      "lead_source": "LANDING_PAGE",
      "name": "creekwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-tulsa-ok",
      "search_query": "luxury apartments with pool Tulsa OK",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Tulsa, OK",
      "h2_subtitle": "Discover Creekwood Apartments, where luxury meets leisure in Tulsa, OK. Experience the perfect blend of style, comfort, and a refreshing poolside retreat.",
      "page_copy": "Experience the epitome of luxury living at Creekwood Apartments, nestled in South Tulsa. Our vibrant community features a sparkling pool, perfect for relaxing on sunny days. With thoughtfully designed one and two-bedroom floor plans, you'll find the ideal space that combines comfort and style. Unwind in our inviting clubhouse or stay active in the modern fitness center, making it easy to achieve a balanced lifestyle.\n\nOur amenities extend beyond the pool, offering high-speed Wi-Fi, a rejuvenating spa, and a serene courtyard for peaceful moments. Creekwood Apartments is the destination for those seeking luxury apartments with pool access in Tulsa, OK. Don't miss the chance to elevate your living experience—schedule a tour today and make this your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Tulsa, OK",
      "seo_description": "Discover luxury living at Creekwood Apartments in Tulsa, OK. Enjoy resort-style amenities including a sparkling pool. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-south-tulsa",
      "search_query": "apartments with in-unit laundry South Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in South Tulsa",
      "h2_subtitle": "Discover the ease of in-unit laundry at Creekwood Apartments. Located in South Tulsa, enjoy convenient living in our stylish one and two-bedroom homes.",
      "page_copy": "Imagine the convenience of doing laundry at home. At Creekwood Apartments, located in South Tulsa, each of our thoughtfully designed one and two-bedroom apartments comes equipped with modern in-unit laundry facilities. This feature ensures you spend less time on chores and more time enjoying the vibrant lifestyle our community offers.\n\nIn addition to in-unit laundry, indulge in the array of amenities such as a sparkling pool, fitness center, and relaxing spa. Our community, nestled in a serene neighborhood, provides a perfect blend of comfort and convenience. If you're seeking apartments with in-unit laundry in South Tulsa, Creekwood Apartments is the ideal choice. Schedule a tour and simplify your life today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry South Tulsa",
      "seo_description": "Enjoy the comfort of in-unit laundry at Creekwood Apartments in South Tulsa. Explore our stylish homes and enjoy an easy living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-74133",
      "search_query": "air conditioned apartments near 74133",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near 74133",
      "h2_subtitle": "Stay comfortable all year round at Creekwood Apartments, near the 74133 area. Enjoy the luxury of air-conditioned living in South Tulsa.",
      "page_copy": "At Creekwood Apartments, located conveniently near the 74133 area, we prioritize your comfort with air-conditioned one and two-bedroom apartment homes. Perfectly suited for South Tulsa living, our residences ensure comfort regardless of the season. The well-designed interiors combine convenience with style, providing you with a perfect blend of comfort and sophistication.\n\nOur vibrant community offers more than just climate-controlled living spaces. Indulge in our resort-style amenities, which include a sparkling swimming pool, a fully-equipped fitness center, and a serene spa. With additional perks like high-speed Wi-Fi and a beautiful courtyard, Creekwood Apartments is a haven of relaxation and leisure. Make the move to our air-conditioned apartments near 74133 and experience the best of Tulsa living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Near 74133",
      "seo_description": "Enjoy year-round comfort in air-conditioned apartments at Creekwood, near 74133. Experience relaxed, premium living in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-tulsa",
      "search_query": "apartments with fitness center Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Tulsa",
      "h2_subtitle": "Enjoy an active lifestyle at Creekwood Apartments. Our Tulsa community offers a state-of-the-art fitness center right at your doorstep.",
      "page_copy": "For fitness enthusiasts, Creekwood Apartments in Tulsa makes staying active easy with our state-of-the-art fitness center. Equipped with modern exercise machines and facilities, you'll have all the resources you need to maintain your workout routine without leaving home. Nestled in South Tulsa, our community offers thoughtfully designed one and two-bedroom homes that blend comfort with convenience.\n\nBeyond our exceptional fitness center, Creekwood Apartments provides a host of resort-style amenities, including a sparkling swimming pool and a relaxing spa. Residents also enjoy high-speed Wi-Fi, a welcoming clubhouse, and serene courtyard spaces. For those seeking apartments with a fitness center in Tulsa, Creekwood Apartments is the ideal choice to elevate your living experience. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Tulsa",
      "seo_description": "Discover Creekwood Apartments in Tulsa, featuring a top-tier fitness center. Live an active lifestyle with premier amenities on-site.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-with-playground-tulsa",
      "search_query": "pet-friendly apartments with playground Tulsa",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Playground in Tulsa",
      "h2_subtitle": "Creekwood Apartments is a pet-friendly community in Tulsa. Enjoy our on-site playground and more in a vibrant setting.",
      "page_copy": "If you're seeking pet-friendly apartments in Tulsa that cater to the whole family, look no further than Creekwood Apartments. Located in the heart of Tulsa, our community is perfect for residents with pets and children. We offer a welcoming environment with a spacious playground where little ones can play and pets can enjoy their daily exercise.\n\nOur thoughtfully designed one and two-bedroom homes are complemented by a variety of amenities. Beyond the playground, enjoy a resort-style swimming pool, a fully-equipped fitness center, and a tranquil spa. Our vibrant community ensures a balanced lifestyle with conveniences like high-speed Wi-Fi and a cozy clubhouse. Make Creekwood Apartments your next home and experience the best in pet-friendly living with a playground in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Playground Tulsa",
      "seo_description": "Discover Creekwood Apartments, a pet-friendly community in Tulsa with a playground. Enjoy spacious living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-south-tulsa",
      "search_query": "1 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover spacious 1 bedroom apartments at Creekwood in South Tulsa. Experience comfort and convenience in a vibrant community.",
      "page_copy": "Creekwood Apartments offers exceptional 1 bedroom apartments in the heart of South Tulsa, designed to blend comfort and style seamlessly. Our homes feature modern interiors with high-quality finishes, perfect for individuals seeking cozy and convenient living spaces. Whether relaxing after a long day or entertaining friends, our apartments provide the ideal setting.\n\nIn addition to thoughtfully designed living spaces, Creekwood Apartments provides an array of premium amenities. Residents enjoy access to a sparkling swimming pool, state-of-the-art fitness center, and serene spa. Located in a vibrant community with high-speed Wi-Fi and a welcoming clubhouse, our 1 bedroom apartments are perfect for those looking to enjoy the best of South Tulsa. Discover your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Tulsa",
      "seo_description": "Experience the comfort of 1 bedroom apartments at Creekwood in South Tulsa. Modern interiors and premium amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165599",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-74133",
      "search_query": "2 bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 74133",
      "h2_subtitle": "Creekwood Apartments offers spacious 2 bedroom homes near the 74133 area. Enjoy resort-style living and modern amenities.",
      "page_copy": "Located near the 74133 area, Creekwood Apartments provides spacious 2 bedroom apartments that cater to those looking for comfort and convenience. Nestled in a prime location, our South Tulsa community offers the perfect blend of style and functionality, ideal for families or roommates seeking generous living spaces with modern finishes.\n\nOur residents enjoy a variety of resort-style amenities that enhance everyday living. From a sparkling swimming pool and relaxing spa to a fully-equipped fitness center, Creekwood Apartments delivers a lifestyle that supports both relaxation and activity. With high-speed Wi-Fi available throughout and a friendly clubhouse atmosphere, our community near 74133 is a place you'll love to call home. Schedule a tour today and discover your perfect living space!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
      "featured_image_media": {
        "alt_text": "Creekwood Apartment Homes monument sign with landscaping.",
        "public_id": "019cfb3d-8148-749c-b0aa-b97694506334",
        "storage_key": "property/6767906449165599/019cfb3d-8148-749c-b0aa-b97694506334.webp",
        "width": 1000,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 74133",
      "seo_description": "Discover spacious 2 bedroom apartments at Creekwood near 74133. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5167"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-VCDHJT78VN"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151393"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/creekwood-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PK9HZX7D"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165599/019d1bd7-ddb1-74d4-ae95-d79858c9dd83.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "9256c5e2-ade5-4ed4-a764-b0012407aa15"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-830-7158"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418537c13f36b6699ca9b0"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im4vSjFyNVBFZ0lYNXo5Um9KbUdOc2c9PSIsInZhbHVlIjoiUlhncFpjMUgrakZ1MEFoRjNvMUdxdz09IiwibWFjIjoiNmI2YWVhY2RjNzYyYjNjMDUwNjBjOTk3YmMwN2MzM2UwM2JiZDRkZmQ1ZDcwNjBjYTVlZmEzYjE0MzVjM2RhNyJ9"
    }
  ],
  "custom_qb_id": "5167",
  "custom_ga4_id": "G-VCDHJT78VN",
  "custom_repli_id": "10041151393",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/creekwood-apartments/register/",
  "custom_google_gtm_id": "GTM-PK9HZX7D",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165599/019d1bd7-ddb1-74d4-ae95-d79858c9dd83.pdf",
  "custom_rentgrata_property_id": "9256c5e2-ade5-4ed4-a764-b0012407aa15",
  "custom_ppc_tracking_phone_number": "855-830-7158",
  "custom_residentboost_apartment_id": "64418537c13f36b6699ca9b0",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im4vSjFyNVBFZ0lYNXo5Um9KbUdOc2c9PSIsInZhbHVlIjoiUlhncFpjMUgrakZ1MEFoRjNvMUdxdz09IiwibWFjIjoiNmI2YWVhY2RjNzYyYjNjMDUwNjBjOTk3YmMwN2MzM2UwM2JiZDRkZmQ1ZDcwNjBjYTVlZmEzYjE0MzVjM2RhNyJ9"
};

export const generatedAt = '2026-08-27T21:38:48.833Z';
